import {dispatch} from '../store';
import axiosInstance from '@/utils/axios';
import API from '@/constant/API';
import * as toolkitRaw from '@reduxjs/toolkit';

const {createSlice} = toolkitRaw.default ?? toolkitRaw;

// ----------------------------------------------------------------------

const initialState = {
  loading: {},
  list: null,
  available: null,
  cardBinList: [],
  billAddress: null,
  shippingAddress: null,
  focusedCardId: ''
};

const slice = createSlice({
  name: 'card',
  initialState,
  reducers: {
    startLoading(state, {payload: type}) {
      const loading = state.loading;
      loading[type] = true;
      state.loading = {...loading};
    },
    stopLoading(state, {payload: type}) {
      const loading = state.loading;
      loading[type] = false;
      state.loading = {...loading};
    },
    onCardBinList(state, {payload: list}) {
      state.cardBinList = list || [];
    },
    onBillAddress(state, {payload}) {
      state.billAddress = payload;
    },
    onShippingAddress(state, {payload}) {
      state.shippingAddress = payload;
    },
    onList(state, {payload: list}) {
      state.list = list || [];
    },
    onAvailable(state, {payload}) {
      state.available = payload;
    },
    onFocusedCardId(state, {payload}) {
      state.focusedCardId = payload;
    }
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  stopLoading,
  onCardBinList,
  onBillAddress,
  onShippingAddress,
  onList,
  onAvailable,
  onFocusedCardId
} = slice.actions;

// ----------------------------------------------------------------------

export function getCardAvailable() {
  return async () => {
    try {
      dispatch(slice.actions.startLoading('getCardAvailable'));
      const responseData = await axiosInstance.post(API.CARD_AVAILABLE);
      dispatch(slice.actions.onAvailable(responseData));
    } finally {
      dispatch(slice.actions.stopLoading('getCardAvailable'));
    }
  }
}

export function getCardList() {
  return async () => {
    try {
      dispatch(slice.actions.startLoading('getCardList'));
      const responseData = await axiosInstance.post(API.CARD_LIST);
      dispatch(slice.actions.onList(responseData));
    } finally {
      dispatch(slice.actions.stopLoading('getCardList'));
    }
  };
}

export function getCardBinList() {
  return async () => {
    try {
      dispatch(slice.actions.startLoading('getCardBinList'));
      const responseData = await axiosInstance.post(API.CARD_BIN_LIST);
      dispatch(slice.actions.onCardBinList(responseData));
    } finally {
      dispatch(slice.actions.stopLoading('getCardBinList'));
    }
  };
}

export function getBillAddress(cardId) {
  return async () => {
    try {
      dispatch(slice.actions.startLoading('getBillAddress'));
      let params = {}
      if (cardId) {
        params = {...params, cardId}
      }
      const responseData = await axiosInstance.post(API.BILL_ADDRESS_INFO, params);
      dispatch(slice.actions.onBillAddress(responseData));
    } finally {
      dispatch(slice.actions.stopLoading('getBillAddress'));
    }
  };
}

export function getShippingAddress() {
  return async () => {
    try {
      dispatch(slice.actions.startLoading('getShippingAddress'));
      const responseData = await axiosInstance.post(API.SHIPPING_ADDRESS_INFO);
      dispatch(slice.actions.onShippingAddress(responseData));
    } finally {
      dispatch(slice.actions.stopLoading('getShippingAddress'));
    }
  };
}
